import * as React from 'react';
import accountProvider from '../account/AccountProvider';
import {getTitleForPath} from '../paths';
import {PageHeader} from 'antd';
import {RouteComponentProps, withRouter} from 'react-router';
import './AppHeader.css';


class AppHeader extends React.Component<RouteComponentProps, {}> {

  public render(): React.ReactNode {
    const onBack = accountProvider.isLoggedIn() ? () => this.props.history.goBack() : undefined;
    const title = getTitleForPath(this.props.location.pathname, accountProvider.isLoggedIn());

    const locationState = this.props.location.state;
    const key = 'appSubtitle';
    const subTitle = locationState && locationState[key];

    return (
      <PageHeader
        className="app-header"
        onBack={onBack}
        title={title}
        subTitle={subTitle}
      />
    );
  }

}

export default withRouter(AppHeader);


export function setAppHeaderSubtitle({history, location}: RouteComponentProps, subtitle: string | undefined) {
  const path = location.pathname + location.search;
  const state = {
    ...location.state,
    appSubtitle: subtitle
  };
  history.replace(path, state);
}


// WEBPACK FOOTER //
// ./src/app/AppHeader.tsx